var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChamadaVideoPerdida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.716 1.69544C21.4835 1.55163 21.193 1.5385 20.9484 1.66072L15.7785 4.24602V2.36678C15.7785 1.05964 14.7189 0 13.4118 0H2.36678C1.05964 0 0 1.05964 0 2.36678V11.8339C0 13.1411 1.05964 14.2007 2.36678 14.2007H13.4118C14.7189 14.2007 15.7785 13.1411 15.7785 11.8339V9.95468L20.9484 12.5439C21.3382 12.7387 21.812 12.5807 22.0068 12.1909C22.0622 12.0801 22.0907 11.9578 22.09 11.8339V2.36678C22.0901 2.09331 21.9486 1.8393 21.716 1.69544ZM7.88929 10.2561C6.14642 10.2561 4.73357 8.84322 4.73357 7.10035C4.73357 5.35748 6.14642 3.94462 7.88929 3.94462C9.63216 3.94462 11.045 5.35748 11.045 7.10035C11.045 8.84322 9.63211 10.2561 7.88929 10.2561Z",
    fill: "#E93F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChamadaVideoPerdida);
export default __webpack_public_path__ + "static/media/chamada-video-perdida.1ca41491.svg";
export { ForwardRef as ReactComponent };